import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";

import "swiper/css";
import { cn } from "@/shared/lib/utils";
import ProjectCardAlt from "@/shared/ui/cards/ProjectCardAlt";
import type { ProjectsType } from "@/entities/projects/model/types";
import SliderArrowButton from "@/shared/ui/buttons/SliderArrowButton";

export interface IProjectSliderProps {
    projects: ProjectsType;
    className?: string;
}

export function ProjectSlider({ projects, className }: IProjectSliderProps) {
    const swiperRef = useRef<SwiperType | null>(null);

    const [winWidth, setWinWidth] = useState(0);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

    let canLoop = false;

    if (winWidth <= 768 && projects.length >= 3) canLoop = true;
    else if (winWidth <= 1440 && projects.length >= 6) canLoop = true;
    else if (winWidth <= 1920 && projects.length >= 8) canLoop = true;

    const handleSwiperNext = () => {
        if (swiperRef.current) swiperRef.current.slideNext();
    };

    const handleSwiperPrev = () => {
        if (swiperRef.current) swiperRef.current.slidePrev();
    };

    useEffect(() => {
        const handleResize = () => setWinWidth(window.innerWidth);

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={cn("w-full h-fit overflow-hidden relative", className)}>
            <SliderArrowButton
                className="absolute z-10 left-[10px] md:left-[32px] lg:left-[150px] xl:left-[200px] top-1/2 -translate-y-1/2"
                arrow="left"
                onClick={handleSwiperPrev}
            />

            <SliderArrowButton
                className="absolute z-10 right-[10px] md:right-[32px] lg:right-[150px] xl:right-[200px] top-1/2 -translate-y-1/2"
                arrow="right"
                onClick={handleSwiperNext}
            />

            <Swiper
                centeredSlides={canLoop}
                direction="horizontal"
                loop={canLoop}
                modules={[]}
                slidesPerView="auto"
                pagination={{ clickable: true }}
                className="mySwiper h-auto"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper)=>{
                    setCurrentSlideIndex(swiper.realIndex);
                }} 
            >
                {projects.map((project, index) => {
                    return (
                        <SwiperSlide
                            key={project.id}
                            className="max-w-[300px] min-h-[300px] md:max-w-[400px] md:min-h-[400px]"
                        >
                            <ProjectCardAlt project={project} isActive={currentSlideIndex == index && winWidth <= 768}/>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
